<h4 class="text-color-theme order-history-bg" mat-dialog-title>{{"order-history"|translate}} <span *ngIf="orderHistory">({{order?.OrderNumber}})</span></h4>
<div *ngIf="orderHistory" class="orderHistory order-history-bg">
  <div class="timeline py-2">
    <div *ngFor='let order of this.orderHistory;let i = index'>
      <div class="container d-flex justify-content-center" [ngClass]="{'left': translate.currentLang == 'en'}">
        <div class="z-index"><span [ngStyle]="{'background-color': getBackgroundColor(order.FixStatus)}" class="circle"></span></div>
        <div class="content">
          <div class="d-flex justify-content-between mb-1">
            <h6 *ngIf="i == this.orderHistory.length-1"
             class="text-color-theme font-weight-bold mb-0">{{ "new-order"|translate}}</h6>
            <h6 *ngIf="titleCancelOrder(order.OrderStatus) && i != this.orderHistory.length-1"
             class="text-color-theme font-weight-bold mb-0">{{ "cancel-req"|translate}}</h6>
             <h6 *ngIf="!titleCancelOrder(order.OrderStatus) && i != this.orderHistory.length-1" class="text-color-theme font-weight-bold mb-0">{{'update' | translate}} |
              <span *ngIf="order.ChancePriceTo != null" class=""> {{ "price"|translate}} </span>
             <span *ngIf="order.ChangeQtyTo != null"> {{ "qty"|translate}} </span>
             <span *ngIf="order.ChangeTiffDateTo"> {{ "validty"|translate}} </span></h6>
            <small>{{order.CreateDate | date: 'dd/MM/yyyy hh:mm'}}</small>
          </div>
          <div class="d-flex align-items-start flex-column">
          <p *ngIf="order.FixStatusEn && order.FixStatusAr" class="mb-0">
          {{ "fix" | translate}} | {{translate.currentLang == 'en'? order.FixStatusEn : order.FixStatusAr}}</p>
          <p *ngIf="order.OrderStatusEn && order.OrderStatusAr" class="mb-0">
          {{ "order-status" | translate}} | {{translate.currentLang == 'en'? order.OrderStatusEn : order.OrderStatusAr}}</p>
          <p *ngIf="order.ChangeTiffDateFlag" class="mb-0">
            {{ "validty" | translate}} | {{translate.currentLang == 'en'? order.ChangeTiffDateFlagEn : order.ChangeTiffDateFlagAr}} {{order.ChangeTiffDateTo| date: 'dd/MM/yyyy' }}</p>
            <p *ngIf="order.ChangeQtyTo != null || order.ChancePriceTo != null" class="mb-0">
              <span *ngIf="order.ChangeQtyTo != null">{{'qty' | translate}} | {{order.ChangeQtyTo| number}} </span>
              <span *ngIf="order.ChancePriceTo != null"> - {{'price' | translate}} | {{order.ChancePriceTo}}</span></p>
              <p *ngIf="order.Remark" class="mb-0">{{'remark'}} | {{order.Remark}}</p>
              <p *ngIf="order.FixText" class="mb-0 text-warning">{{order.FixText}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div  *ngIf="!orderHistory && noData == false" class="d-flex justify-content-center align-items-center">
  <div  class="spinner-border  text-secondary m-5" role="status">
    <span class="sr-only"></span>
  </div>
  </div>
<div  *ngIf="!orderHistory && noData == true" class="d-flex justify-content-center align-items-center">
  <div class="row no-data m-0">
    <div class="col-md-12">
      <!-- <img class="empty-state" src="/assets/img/noData.png" /> -->
      <img class="empty-state" src="/assets/img/noData.png" />

      <div class="col-sm-12">
        <h6> {{"no-history-hint"|translate}} </h6>
      </div>
    </div>
  </div>
  </div>
